import React from 'react'
import Background from '../../pb_background/_background'

const BackgroundLight = (props) => (
  <Background
      padding="xl"
      {...props}
  />
)

export default BackgroundLight
